// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Rxzg","right":"Footer_right__2PqzX","buttons":"Footer_buttons__2m4kL"};